import React, { useContext, useEffect, useState } from 'react';
import { useFormikContext } from "formik";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import CsplAchField from '../../CsplControls/CsplAch/CsplAchField';
import CsplLabel from '../../CsplControls/CsplLabel/CsplLabel';
import CsplTextBoxField from '../../CsplControls/CsplTextBox/CsplTextBoxField';
import styles from './NominationDetail.module.css';
import { NomineesEnum } from "../../../Enumeration/NomineesEnum";
import { useTranslation } from 'react-i18next';
import TagValueResource from '../../Resources/CommonResources/TagValueResource';
import { TagEnum } from '../../../Enumeration/TagEnum';
import { TagValueEnum } from '../../../Enumeration/TagValueEnum';
import CountryResource from "../../Resources/CommonResources/CountryResource";
import { defaultMobileCountryCode } from "../../../Utils/GlobalValues";
export default function GaurdianNominee() {
  const { t } = useTranslation("common");
    const [countryId, setCountryId] = useState();
    const applicationContext = useContext(KycApplicationContext);
    const { values, setFieldValue } = useFormikContext();
    const [relationshipId, setRelationshipId] = useState(null);
    const [disable, setDisable] = useState(true);
    const [getTagValue] = TagValueResource();
    const {getCountryByMobileCountryCode} = CountryResource();
    
  //Set enable/disable the control
  // disable if it is in view mode
  let isDisabled = applicationContext.disableForm;
  //handling country change
  const handleCountryChange =(value) =>{
     setFieldValue(
      "nomineeWidgetDTO.nominee1.guardianDTO.state",
      null
    ); 
    if(value && value.mobileCountryCode && value.mobileCountryCode != ""){
      setFieldValue(
        "nomineeWidgetDTO.nominee1.guardianDTO.mobileCountry",
        value
      );
    }else{
      setFieldValue(
        "nomineeWidgetDTO.nominee1.guardianDTO.mobileCountry",
        null
      );
    }
  }

  const handleRelationship = (newValue) => {
    if (newValue && newValue.name === NomineesEnum.relationship_others) {
      setDisable(false);
      values.nomineeWidgetDTO.nominee1.guardianDTO.otherRelationshipRequired = true;
    } else if (
      newValue &&
      (newValue.name !== NomineesEnum.relationship_others)
    ) {
      setDisable(true);
      values.nomineeWidgetDTO.nominee1.guardianDTO.otherRelationship = "";
      values.nomineeWidgetDTO.nominee1.guardianDTO.otherRelationshipRequired = false;
    }
  };

  //If User Select relationship as 'Others', enable the textbox
  useEffect(() => {
    if (
      values.nomineeWidgetDTO.nominee1 &&
      values.nomineeWidgetDTO.nominee1.guardianDTO &&
      values.nomineeWidgetDTO.nominee1.guardianDTO.relationship
    ) {
      handleRelationship(values.nomineeWidgetDTO.nominee1.guardianDTO.relationship);
    } else if (
      values.nomineeWidgetDTO.nominee1 && 
      values.nomineeWidgetDTO.nominee1.guardianDTO &&
      values.nomineeWidgetDTO.nominee1.guardianDTO.relationship === null
    ) {
      handleRelationship({ name: NomineesEnum.relationship_nan });
    }
  }, [relationshipId, handleRelationship]);

    /*set Default Values */
    useEffect(() => {
      if (
        values &&
        values.nomineeWidgetDTO &&
        values.nomineeWidgetDTO.nominee1 &&
        values.nomineeWidgetDTO.nominee1.guardianDTO
      ) {
        //set default account type
        //setdefaultAccountType();
        //set default mobile country
        setdefaultMobileCountry();
      }
    }, []) 

     //set default Mobile Country
     function setdefaultMobileCountry(){
      if (
        values.nomineeWidgetDTO.nominee1.guardianDTO.mobileCountry == null ||
        values.nomineeWidgetDTO.nominee1.guardianDTO.mobileCountry == undefined
      ) {
        getCountryByMobileCountryCode(defaultMobileCountryCode).then(
          (res) => {
            console.log(res);
            setFieldValue(
              "nomineeWidgetDTO.nominee1.guardianDTO.mobileCountry",
              res
            );
          },
          (error) => {}
        );
      }
    }
  
    /*set Default account type */
    function setdefaultAccountType(){
      if (
        values.nomineeWidgetDTO.nominee1.guardianDTO.bankAccountType == null
      ) {
        getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
          (res) => {
            setFieldValue(
              "nomineeWidgetDTO.nominee1.guardianDTO.bankAccountType",
              res
            );
          },
          (error) => {}
        );
      }
    }

    return (
      <>
        {/* Get the Guardian Details if user is minor */}
        <div>
          <div className="row">
            {/* Overall width control */}
            <div className="col-12 mx-auto ">
            <p><span className={styles.file_instruction}>{t("nominee.guardianHelpText")}</span></p>
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <p className={styles.gaurdian_header}>
                <CsplLabel label={"nominee.guardianDetail"}></CsplLabel>
              </p>
              </div>

              {/*Name*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.name"
                  required={true}
                  label={"nominee.name"}
                  disabled={isDisabled}
                  id="guardianName"
                ></CsplTextBoxField>
              </div>

              
            {/*Relationship & otherRelationship*/}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                <CsplAchField
                    lookupName={"guardianRelationship"}
                    displayColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee1.guardianDTO.relationship"
                    required={true}
                    label={"nominee.relationshipWithNominee"}
                    disabled={isDisabled}
                    id="guardianRelationship"
                    getIdValue={setRelationshipId}
                  ></CsplAchField>
                </div>
                <div className="w-100">
                <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee1.guardianDTO.otherRelationship"
                    required={
                      values.nomineeWidgetDTO.nominee1.guardianDTO !== null && values.nomineeWidgetDTO.nominee1.guardianDTO.otherRelationshipRequired
                    }
                    disabled={isDisabled || disable}
                    label={"nominee.otherRelationship"}
                    id="guardianOtherRelationship"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>

              {/*AddressLine1*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.addressLine1"
                  required={false}
                  label={"nominee.addressLine1"}
                  disabled={isDisabled}
                  id="guardianAddressLine1"
                ></CsplTextBoxField>
              </div>

              {/*AddressLine2*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.addressLine2"
                  required={false}
                  label={"nominee.addressLine2"}
                  disabled={isDisabled}
                  id="guardianAddressLine2"
                ></CsplTextBoxField>
              </div>

              {/*AddressLine3*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.addressLine3"
                  required={false}
                  label={"nominee.addressLine3"}
                  disabled={isDisabled}
                  id="guardianAddressLine3"
                ></CsplTextBoxField>
              </div>

              {/* City & Country */}

              <div className=" col-sm-11 col-12 mb-4 me-auto">
                <div className="d-md-flex justify-content-between">
                  <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                    <CsplTextBoxField
                      name="nomineeWidgetDTO.nominee1.guardianDTO.city"
                      required={true}
                      label={"nominee.city"}
                      disabled={isDisabled}
                      id="guardianCity"
                    ></CsplTextBoxField>
                  </div>
                  <div className="w-100">
                    <CsplAchField
                      lookupName={"country"}
                      displayColumn="name"
                      idColumn="id"
                      name="nomineeWidgetDTO.nominee1.guardianDTO.country"
                      required={true}
                      label={"nominee.country"}
                      disabled={isDisabled}
                      id="guardianCountry"
                      getIdValue={setCountryId}
                      onValueChange={handleCountryChange}
                    ></CsplAchField>
                  </div>
                </div>
              </div>

              {/* State & Pincode */}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <div className="d-md-flex justify-content-between">
                  <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                    <CsplAchField
                      lookupName="state"
                      displayColumn="name"
                      idColumn="id"
                      id="guardianState"
                      label="nominee.state"
                      name="nomineeWidgetDTO.nominee1.guardianDTO.state"
                      required={true}
                      filterValue={countryId}
                      disabled={isDisabled}
                    />
                  </div>
                  <div className="w-100">
                    <CsplTextBoxField
                      name="nomineeWidgetDTO.nominee1.guardianDTO.pincode"
                      required={true}
                      label={"nominee.pincode"}
                      disabled={isDisabled}
                      id="guardianPincode"
                    ></CsplTextBoxField>
                  </div>
                </div>
              </div>

              {/*Mobile Number & email*/}
              <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                <CsplAchField
                    lookupName={"mobileCountry"}
                    displayColumn="mobileCountryCode"
                    secondaryColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee1.guardianDTO.mobileCountry"
                    required={true}
                    label={"nominee.mobileCountryCode"}
                    disabled={isDisabled}
                    id="guardian1Mobilecountry"
                  />
                
                </div>
                <div className="w-100">
                   <CsplTextBoxField
                      name="nomineeWidgetDTO.nominee1.guardianDTO.mobileNo"
                      required={true}
                      label={"nominee.mobileno"}
                      disabled={isDisabled}
                      id="guardianMobileno"
                    ></CsplTextBoxField>
                </div>
              </div>
            </div>

             {/*email*/}

             <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.emailId"
                  required={true}
                  label={"nominee.email"}
                  disabled={isDisabled}
                  id="guardianEmail"
                ></CsplTextBoxField>
              </div>

              {/*Bank Name*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.bankName"
                  required={false}
                  label={"nominee.bankName"}
                  disabled={isDisabled}
                  id="guardianBankName"
                ></CsplTextBoxField>
              </div>

              {/*IFSC code*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.ifscCode"
                  required={false}
                  label={"nominee.ifscCode"}
                  disabled={isDisabled}
                  id="guardianIfscCode"
                ></CsplTextBoxField>
              </div>

              {/*Branch Name*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.branchName"
                  required={false}
                  label={"nominee.branchName"}
                  disabled={isDisabled}
                  id="guardianBranchName"
                ></CsplTextBoxField>
              </div>

              {/*Bank Account Number*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplTextBoxField
                  name="nomineeWidgetDTO.nominee1.guardianDTO.bankAccountNumber"
                  required={false}
                  label={"nominee.bankAccNo"}
                  disabled={isDisabled}
                  id="guardianBankAccNo"
                ></CsplTextBoxField>
              </div>

              {/*Bank Account Type accountType*/}

              <div className="col-sm-11 col-12 mb-4 me-auto">
                <CsplAchField
                      lookupName={"accountTypeExcludeCode"}
                      displayColumn="name"
                      idColumn="id"
                      name="nomineeWidgetDTO.nominee1.guardianDTO.bankAccountType"
                      required={false}
                      label={"nominee.bankAccType"}
                      disabled={isDisabled}
                      id="guardianBankAccType"
                    ></CsplAchField> 
              </div>
            </div>
          </div>
        </div>
      </>
    );
}